// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const DeletePlanDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-deleteplandialogcontainer" */ "./DeletePlanDialogContainer")).then((bundle)=>{
        return {
            default: bundle.DeletePlanDialogContainer
        };
    });
export const LazyDeletePlanDialogContainer = /*#__PURE__*/ lazy(DeletePlanDialogContainerLazyLoader);
